<template>
  <div 
    class="fts-radio"
    :class="[
      {'comfort-design': comfortDesign},
      {'disabled': disabled},
      {'active': model === optionValue}  
    ]"
  >
    <div class="radio-control__input">
      <div class="radio-icon-ring"></div>
      <div class="radio-icon-dot"></div>
      <input
        :id="`fts-radio-${this.uid}`"
        type="radio"
        role="radio"
        :name="`${groupName}`"
        :value="optionValue"
        :disabled="disabled"
        v-model="model"
      >
    </div>
    <label
      :for="`fts-radio-${this.uid}`"
      class="radio-control__label"
    >
      {{optionLabel}}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    groupName: String,
    optionId: [String, Number],
    optionLabel: String,
    optionValue: [String, Number],
    value: [String, Number],
    valueId: [String, Number],
    disabled: Boolean,
    comfortDesign: Boolean,
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  data: () => ({
    uid: null,
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('updateValue', val);
        this.$emit('update:valueId', this.optionId);
      }
    },
  },
  mounted() {
    this.uid = this._uid
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-radio {
  $border-width: 1px;
  $size: var(--inistate-paragraph-text-14--line-height);
  $size-ring: var(--inistate-paragraph-text-14--line-height);
  $size-dot: calc(var(--inistate-paragraph-text-14--line-height) * 0.6);
  display: inline-flex;
  align-items: center;
  font-size: var(--inistate-label-text-14);
  line-height: var(--inistate-paragraph-text-14--line-height);
  .radio-control__input {
    position: relative;
    height: $size;
    width: $size;
    flex-shrink: 0;
    margin-right: 0.5rem;
    border-radius: 50%;
    overflow: hidden;
    transition: all .3s ease-in-out;
    cursor: pointer;
    .radio-icon-ring {
      @include absolute-center-middle;
      height: $size-ring;
      width: $size-ring;
      border: $border-width solid var(--fts-form-label);
      border-radius: inherit;
      transition: inherit;
    }
    .radio-icon-dot {
      @include absolute-center-middle;
      height: $size-dot;
      width: $size-dot;
      border-radius: inherit;
      transition: inherit;
    }
    input[role="radio"] {
      @include user-select-none;
      position: absolute;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      cursor: inherit;
    }
  }
  .radio-control__label {
    color: var(--fts-text);
    overflow-wrap: break-word;
    word-break: break-word;
    cursor: pointer;
  }
  &.active {
    .radio-icon-ring {
      border-color: var(--fts-primary);
    }
    .radio-icon-dot {
      background-color: var(--fts-primary);
    }
  }
  &.disabled {
    .radio-control__input {
      cursor: not-allowed;
    }
    .radio-control__label {
      cursor: not-allowed;
    }
  }
  &.comfort-design {
    $size: $comfort-font-size * $comfort-line-height;
    $size-ring: $comfort-font-size * $comfort-line-height - pxToRem($border-width);
    $size-dot: #{floor(stripUnit($size * 0.5) * 16)}px;
    .radio-control__input {
      height: $size;
      width: $size;
      margin-right: 0.5rem;
      .radio-icon-ring {
        height: $size-ring;
        width: $size-ring;
      }
      .radio-icon-dot {
        height: $size-dot;
        width: $size-dot;
      }
    }
    .radio-control__label {
      font-size: $comfort-font-size;
      line-height: $comfort-line-height;
    }
  }
}
</style>